import * as React from "react"

const BillingSVG = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={19} height={20} fill="none" {...props}>
		<path
			stroke="#475163"
			strokeLinecap="round"
			strokeWidth={1.5}
			d="M17.375 5.625v-.551c0-1.044 0-1.567-.138-1.986a2.663 2.663 0 0 0-1.646-1.695c-.41-.143-.916-.143-1.93-.143H5.339c-1.014 0-1.52 0-1.93.143a2.665 2.665 0 0 0-1.646 1.694c-.138.421-.138.943-.138 1.987v7.551m15.75-3.5v8.202c0 .751-.862 1.15-1.407.651a.828.828 0 0 0-1.123 0l-.423.387a1.45 1.45 0 0 1-1.969 0 1.45 1.45 0 0 0-1.969 0 1.45 1.45 0 0 1-1.968 0 1.45 1.45 0 0 0-1.97 0 1.45 1.45 0 0 1-1.968 0l-.423-.387a.828.828 0 0 0-1.123 0c-.545.499-1.407.1-1.407-.65v-1.203"
		/>
		<path stroke="#475163" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="m7.313 8.6 1.25 1.4 3.124-3.5" />
		<path stroke="#475163" strokeLinecap="round" strokeWidth={1.5} d="M5.563 13.063h1.312m6.563 0H9.5" />
	</svg>
)

export default BillingSVG
